/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Focus_MuscleInputs */

const en_us2_quick_workout_focus_muscle = /** @type {(inputs: Quick_Workout_Focus_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One muscle`)
};

const pt_br2_quick_workout_focus_muscle = /** @type {(inputs: Quick_Workout_Focus_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um músculo`)
};

const es_419_quick_workout_focus_muscle = /** @type {(inputs: Quick_Workout_Focus_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un músculo`)
};

const pt_pt2_quick_workout_focus_muscle = /** @type {(inputs: Quick_Workout_Focus_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um músculo`)
};

const fr_fr2_quick_workout_focus_muscle = /** @type {(inputs: Quick_Workout_Focus_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un muscle`)
};

const de_de2_quick_workout_focus_muscle = /** @type {(inputs: Quick_Workout_Focus_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Muskel`)
};

const it_it2_quick_workout_focus_muscle = /** @type {(inputs: Quick_Workout_Focus_MuscleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un muscolo`)
};

/**
* | output |
* | --- |
* | "One muscle" |
*
* @param {Quick_Workout_Focus_MuscleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_focus_muscle = /** @type {((inputs?: Quick_Workout_Focus_MuscleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Focus_MuscleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_focus_muscle(inputs)
	if (locale === "es-419") return es_419_quick_workout_focus_muscle(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_focus_muscle(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_focus_muscle(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_focus_muscle(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_focus_muscle(inputs)
	return en_us2_quick_workout_focus_muscle(inputs)
});
export { quick_workout_focus_muscle as "quick-workout.focus_muscle" }